<template>
    <form class="form__item a-modal__separator">
        <div class="form__item">
            <el-switch :inactive-text="$lang('admin.addPartner.domain.title')" class="switch switch--small switch--label" v-model="form.enabled"></el-switch>
        </div>
        <div class="form__item" v-if="form.enabled">
            <div class="form__item form__item--inline">
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.host') }}</span>
                    <el-popover v-model="errors.host.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.host.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.host.isErrorPaint }"
                                  :readonly="readonly"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.host.placeholder')" class="input input--big"
                                  v-model="form.host"></el-input>
                    </el-popover>
                </label>
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.port') }}</span>
                    <el-popover v-model="errors.port.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.port.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.port.isErrorPaint }"
                                  :readonly="readonly"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.port.placeholder')" class="input input--big"
                                  v-model="form.port"></el-input>
                    </el-popover>
                </label>
            </div>
            <div class="form__item form__item--inline">
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.user') }}</span>
                    <el-popover v-model="errors.user.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.user.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.user.isErrorPaint }"
                                  :readonly="readonly"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.user.placeholder')" class="input input--big"
                                  v-model="form.user"></el-input>
                    </el-popover>
                </label>
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.pass') }}</span>
                    <el-popover v-model="errors.password.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.password.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.password.isErrorPaint }"
                                  :showPassword="true" @focus="clearErrors"
                                  :readonly="readonly"
                                  :placeholder="$lang('admin.addPartner.domain.pass.placeholder')" class="input input--big"
                                  v-model="form.password"></el-input>
                    </el-popover>
                </label>
            </div>
            <div class="form__item form__item--inline">
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.domain') }}</span>
                    <el-popover v-model="errors.domain.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.domain.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.domain.isErrorPaint }"
                                  :readonly="readonly"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.domain.placeholder')" class="input input--big"
                                  v-model="form.domain"></el-input>
                    </el-popover>
                </label>
                <label class="form__inner">
                    <span class="form__label">{{ $lang('admin.addPartner.domain.folder') }}</span>
                    <el-popover v-model="errors.dir.isError"
                                trigger="manual"
                                placement="top"
                                width="300"
                                popper-class="add__error-popover"
                                :content="errors.dir.message">
                        <el-input slot="reference"
                                  :class="{ 'add__error': errors.dir.isErrorPaint }"
                                  :readonly="readonly"
                                  @focus="clearErrors"
                                  :placeholder="$lang('admin.addPartner.domain.folder.placeholder')" class="input input--big"
                                  v-model="form.dir"></el-input>
                    </el-popover>
                </label>
            </div>
            <div class="form__item">
                <button v-if="form.connected" class="btn btn--small btn--main-bg" @click.prevent="disconnect">
                    {{ $lang('admin.addPartner.domain.disconnect') }}
                </button>

                <button v-else class="btn btn--small btn--main-bg" @click.prevent="connect">
                    {{ $lang('admin.addPartner.domain.connect') }}
                </button>
            </div>
        </div>
        <div class="form__item" v-if="form.connected">
            <div class="form__item">
                <span class="form__label">{{ $lang('admin.addPartner.domain.logo') }}</span>
                <div class="upload-photo__inner">
                    <div class="form__inner upload-photo__avatar-box">
                        <label class="btn upload-photo__avatar" v-if="!imgSrc && form.logo == null && !load">
                            <input type="file" accept="image/*" class="upload-photo__input" @change="setImage">
                            <span class="upload-photo__avatar-inner">
                                        <svg width="21" height="21">
                                            <use xlink:href="/assets/front/img/sprite.svg#icon-camera"></use>
                                        </svg>
                                    <span class="upload-photo__avatar-text">{{ $lang('admin.addPartner.domain.logo.add') }}</span>
                                    </span>
                        </label>
                        <img src="/assets/front/img/spinner.svg" v-if="imgSrc == null && load" style="width:280px; height:280px">
                        <vue-cropper v-if="imgSrc && form.logo == null"
                                     ref="cropper"
                                     :guides="true"
                                     :view-mode="2"
                                     drag-mode="crop"
                                     :auto-crop-area="0.5"
                                     :min-container-width="300"
                                     :min-container-height="300"
                                     :background="true"
                                     :rotatable="false"
                                     :src="imgSrc"
                                     :img-style="{ 'width': '300px', 'height': '300px' }"
                        ></vue-cropper>
                        <button type="button" @click="cropImage" v-if="imgSrc && form.logo == null"
                                style="margin-top: 10px;" class="btn btn--small btn--main-bg add__video-button">
                            {{ $lang('admin.addPartner.domain.logo.crop') }}
                        </button>
                        <img v-if="form.logo" :src="form.logo" class="upload-photo__avatar-img"
                             style="width:280px; height:280px">
                        <button type="button" @click="deleteImage" v-if="form.logo"
                                style="margin-top: 10px;"
                                class="btn btn--small btn--main-bg add__video-button">{{ $lang('admin.addPartner.domain.logo.delete') }}
                        </button>
                    </div>
                    <div class="form__inner">
                        <span class="upload-photo__hint upload-photo__hint--m">{{ $lang('admin.addPartner.domain.logo.hint') }}</span>
                    </div>
                </div>
            </div>
            <div class="form__item">
                <span class="form__label">{{ $lang('admin.addPartner.domain.sitename') }}</span>
                <el-popover v-model="errors.sitename.isError"
                            trigger="manual"
                            placement="top"
                            width="300"
                            popper-class="add__error-popover"
                            :content="errors.sitename.message">
                    <el-input slot="reference"
                              :class="{ 'add__error': errors.sitename.isErrorPaint }"
                              @focus="clearErrors"
                              :placeholder="$lang('admin.addPartner.domain.sitename.placeholder')" class="input input--big"
                              v-model="form.sitename"></el-input>
                </el-popover>
            </div>
            <div class="form__item">
                <button class="btn btn--small btn--main-bg" @click.prevent="upload">
                    {{ $lang('admin.addPartner.domain.exportPages') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
import {mapActions, mapState, mapMutations} from "vuex";
import mixin from "../../mixins/errors";
import helper from "../../mixins/helper";
import VueCropper from "vue-cropperjs/VueCropper";
import Vue from "vue";

export default {
    name: 'RemoteHostConnect',
    mixins: [mixin, helper],
    components: { VueCropper },
    props: {
        partnerId: {
            type: Number,
            default: null
        },
        enabledResetForm: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        imgSrc: null,
        load: false,
        readonly: false,
        errors: {
            host: {isError: false, message: ''},
            port: {isError: false, message: ''},
            user: {isError: false, message: ''},
            password: {isError: false, message: ''},
            domain: {isError: false, message: ''},
            dir: {isError: false, message: ''},
            logo: {isError: false, message: ''},
            sitename: {isError: false, message: ''},
        },
    }),
    mounted() {
        this.$on('reset-form', () => {
            this.resetForm();
        });

        if (this.partnerId) {
            if (this.enabledResetForm) {
                this.resetForm();
            }

            this.wrapperRemoteHostShow();
        }
    },
    computed: {
        ...mapState('remoteHost', {
            storeForm: state => state.form
        }),
        form: {
            get() {
                return this.storeForm;
            },
            set(val) {
                this.setForm(val);
            }
        }
    },
    watch: {
        'form.enabled': function(val) {
            if(!val) {
                this.disable();
            }
        }
    },
    methods: {
        ...mapActions('remoteHost', [
            'remoteHostShow',
            'remoteHostConnect',
            'remoteHostDisconnect',
            'remoteHostUploadPages',
            'resetForm'
        ]),
        ...mapMutations('remoteHost', [
           'setForm'
        ]),
        wrapperRemoteHostShow() {
            this.remoteHostShow(this.partnerId)
                .then((response) => {
                    if (response.data.form) {
                        let form = ['host', 'port', 'user', 'password', 'dir', 'domain', 'sitename', 'enabled', 'connected'];

                        form.forEach((key) => {
                            this.form[key] = response.data.form[key];
                        });

                        if(response.data.form.connected) {
                            this.readonly = true;
                        }
                    }

                    if(response.data.logo) {
                        this.form.logo = response.data.logo;
                    }
                })
        },
        disable() {
            this.remoteHostDisconnect({id: this.partnerId, form: this.form})
                .then((response) => {
                    this.form.enabled = false;
                    this.form.connected = false;
                    this.readonly = false;
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                });
        },
        connect() {
            this.$loading(this.$optionsLoading);

            this.remoteHostConnect({id: this.partnerId, form: this.form})
                .then((response) => {
                    this.form.connected = true;
                    this.readonly = true;
                })
                .catch((error) => {
                    if(error.response.status === 500) {
                        this.$appNotify.error(this.$lang('admin.addPartner.domain.connectError'));
                    } else {
                        this.createErrors(error.response.data.errors);
                    }
                })
                .finally(() => {
                    this.$loading({}).close();
                })
        },
        disconnect() {
            this.$loading(Vue.prototype.$optionsLoading);

            this.remoteHostDisconnect({id: this.partnerId, form: this.form})
                .then((response) => {
                    this.form.connected = false;
                    this.readonly = false;
                })
                .catch((error) => {
                    this.createErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        upload() {
            this.$loading(Vue.prototype.$optionsLoading);

            this.remoteHostUploadPages({id: this.partnerId, form: this.form})
                .then((response) => {
                    this.$appNotify.success(this.$lang('admin.addPartner.domain.success'));
                })
                .catch((error) => {
                    this.$appNotify.error(this.$lang('admin.addPartner.domain.exportError'));
                })
                .finally(() => {
                    this.$loading({}).close();
                });
        },
        setImage(e) {
            this.load = true;

            const file = e.target.files[0];

            if (!file.type.includes("image/")) {
                alert(this.$lang('admin.addPartner.domain.logo.pleaseSelectImage'));
                this.load = false;
                return;
            }
            if (typeof FileReader === "function") {
                const reader = new FileReader();

                reader.onload = event => {
                    this.downscaleImage(event.srcElement.result, 870, file.type, (data) => {
                        this.imgSrc = data;
                        this.load = false;
                        this.$refs.cropper.replace(data);
                    });
                };

                reader.readAsDataURL(file);
            } else {
                this.load = false;
                alert(this.$lang('admin.addPartner.domain.logo.apiNotSupported'));
            }
        },
        cropImage() {
            this.form.logo = this.$refs.cropper.getCroppedCanvas().toDataURL();
        },
        deleteImage() {
            this.form.logo = null;
            this.imgSrc = null;
        },
    }
}
</script>

<style>
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader--img .el-upload {
    border: none !important;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}
.avatar {
    width: 150px;
    height: 150px;
    display: block;
}
</style>
